"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CircleCheck, Target, TrendingUp } from "lucide-react";
export default function ComoFuncionaElCoaching() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const steps = [{
    number: "01",
    title: "Evaluación",
    description: "Identificamos tus bloqueos, patrones de autosabotaje y puntos de estancamiento para entender con claridad qué te está frenando hoy.",
    icon: Target
  }, {
    number: "02",
    title: "Trabajo",
    description: "Sesiones prácticas y personalizadas donde trabajamos directamente sobre tu forma de pensar para desbloquear tu mente y recuperar confianza.",
    icon: TrendingUp
  }, {
    number: "03",
    title: "Resultados",
    description: "Ganas claridad, reduces el autosabotaje y avanzas con más seguridad hacia los objetivos que hoy te importan.",
    icon: CircleCheck
  }];
  return <section ref={ref} className="bg-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className={`font-display text-3xl font-semibold text-foreground md:text-4xl lg:text-5xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Cómo funciona el coaching
          </h2>
          <p className={`mt-4 text-lg text-muted-foreground transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>Un proceso claro y personalizado para ayudarte a avanzar de verdad.</p>
        </div>

        <div className="relative grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-6">
          {}
          <div className="absolute left-0 top-1/3 hidden h-0.5 w-full md:block">
            <div className={`h-full bg-primary transition-all duration-[1200ms] ease-[var(--ease-smooth)] ${isVisible ? "w-full" : "w-0"}`} />
          </div>

          {steps.map((step, i) => {
          const Icon = step.icon;
          return <Card key={i} data-index={i} className={`relative z-10 hover-lift transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader className="items-center text-center">
                  <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
                    <Icon className="h-10 w-10 text-primary" />
                  </div>
                  <div className="mb-2 font-display text-5xl font-bold text-primary/20">
                    {step.number}
                  </div>
                  <CardTitle className="text-2xl">{step.title}</CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}